<template>
  <div class="flex items-center gap-2.5 text-xs whitespace-nowrap text-muted-foreground">
    <info-popup>
      <b>{{ tr('How Credits Work') }}</b>
      <ul>
        <li><b>{{ tr('Cost') }}:</b> {{ tr('1 generation costs 1 credit.') }}</li>
        <li><b>{{ tr('Available') }}:</b> {{ tr('Credits you have left for the current billing period.') }}</li>
        <li><b>{{ tr('Limit') }}:</b> {{ tr('The total number of credits included in your plan. This limit resets based on your subscription (e.g., monthly or yearly).') }}</li>
      </ul>
    </info-popup>
    <span>
      {{ tr('Available Credits') }}:
      <b class="font-semibold text-foreground tabular-nums">{{ availableCredits }}</b>
      <span v-tooltip="totalLabel" class="tabular-nums"> / {{ maxLimit }}</span>
    </span>
    <ui-progress :model-value="maxLimit ? availableCredits / maxLimit * 100 : 0" class="h-1.5 w-16 shrink-0" />
  </div>
</template>

<script>
import InfoPopup from '@/ui/components/InfoPopup.vue';

export default {
  name: 'CreatorCreditCounter',
  components: {
    InfoPopup,
  },
  computed: {
    currentPackage() {
      return this.$root.currentCompany.current_subscription?.package;
    },
    maxLimit() {
      const currentCredits = this.$root.currentCompany.creator_credits;
      const creditsInPackage = this.currentPackage?.creator_credits ?? 0;

      if (currentCredits > creditsInPackage) {
        return currentCredits;
      }

      return creditsInPackage;
    },
    availableCredits() {
      return this.$root.currentCompany.creator_credits;
    },
    totalLabel() {
      if (this.currentPackage?.is_free_trial) {
        return this.tr('Free Limit');
      }

      switch (this.currentPackage?.period) {
        case 'monthly':
          return this.tr('Monthly Limit');

        case 'annual':
          return this.tr('Annual Limit');
      }

      return null;
    },
  },
};
</script>
